// CollapseCard.jsx
import React from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronDown } from "lucide-react";
import clsx from "clsx";

export default function CollapseCard({
  title,
  children,
  isOpen = false,
  onToggle = () => {},
  right,
}) {
  return (
    <Disclosure open={isOpen} onChange={onToggle}>
      {({ open }) => (
        <div className="rounded-xl border bg-white shadow-sm">
          <Disclosure.Button
            className="flex w-full justify-between px-4 py-3"
            aria-expanded={open}
            type="button"
          >
            <span className="font-medium">{title}</span>
            {right}
            <ChevronDown
              className={`h-5 w-5 transition-transform ${open ? 'rotate-180' : ''}`}
            />
          </Disclosure.Button>

          <Disclosure.Panel className="border-t px-4 py-4 space-y-4">
            {children}
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
}


